import {Injectable} from '@angular/core';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

function isNumber(value: any): boolean {
  return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}


@Injectable()
export class NgbDateUsFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    let d: NgbDateStruct;
    if (value) {
      let p = value.split('-');
      d = {year: parseInt(p[2], 10), month: parseInt(p[1], 10), day: parseInt(p[0], 10)};
    }
    return d ? d : null;
  }

  format(date: NgbDateStruct): string {
    let stringDate: string = '';
    if (date) {
      stringDate += isNumber(date.month) ? padNumber(date.month) + '-' : '';
      stringDate += isNumber(date.day) ? padNumber(date.day) + '-' : '';
      stringDate += date.year;
    }
    return stringDate;
  }
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shared/ngb-date-us-formatter.ts